import * as React from 'react';
import AppView from   '~common/components/app-view/index';
import translate from "~common/components/i18n/i18n.js"
import { Input, InputLabel, InputAdornment } from '@mui/material';

import { FormControl } from '@mui/material';
import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { TextField, Select, MenuItem} from '@mui/material';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { Paper } from '@mui/material';
import { Grid } from '@mui/material';

import MFAMethodSelect from "../components/mfa-method-select"
import MfaEmailSetup from '../components/mfa-email-setup';
import MFAAuthenticatorSetup from "../components/mfa-authenticator-setup"
import ChangePassword from "../components/reset-change-password"


const styles = (theme: Theme): StyleRules => ({
	container: {
		marginTop: 40,
		display: 'flex',
		justifyContent: 'center'
	},
	paper: {
		width: 740,
		padding: 30,
		backgroundColor: 'white'
	},
	textField: {
		marginTop: 15,
		width: 350
	},
	passwordField: {
		width: 350
	},
	textFieldFull: {
		marginTop: 15,
		width: '100%'
	},
	passwordFull: {
		width: '100%'
	},
	form: {
		textAlign: 'left'
	},
	buttonBar: {
		textAlign: 'right',
		marginTop: 30
	},
	button: {
		width: 100
	},
	noButton:{
		marginRight: 15,
		width: 100
	},
	altButton: {
		width: 250
	},
	resetInstructions: {
		marginTop: 30
	},
	gridItem: {
		padding: 15,
		backgroundColor: 'white'
	},
	centalArea: {
		minHeight: 200
	},
	employeeInstructions: {
		paddingTop: 45
	},
	gridItemSep: {
		backgroundColor: '#fafafa',
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center'
	}
});



interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {
	showPassword: boolean;
	data: any;
	redirectURL: string;
	requireCaptchaVerify: boolean;
	requirePasswordChange?: boolean;
	requireOTP?: boolean;
	requireMFAEnroll?: boolean;
	mfaMethod?: any;
	qr?: any;
	setupCode?: any;
	userName?: any;
	mfaEnrollSuccess?: any;
	notifyPasswordExpiring: boolean
	preferredLanguage?: string
};

class LoginView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});

		// Determine if the user has a prefered language configured other than English
		var preferredLanguage:string = "en-US"
		preferredLanguage = navigator.language || preferredLanguage;

		// QueryString lang will override navigator.language
		const qp = new URLSearchParams(window.location.search);
		if (qp != null) {
			if (qp.get("lang") != null) {
				preferredLanguage = qp.get("lang") || "en-US";
			}
		}

		this.state = {
			showPassword: false,
			data: {
				userName: '',
				password: ''
			},
			redirectURL: '',
			requireCaptchaVerify: true,
			notifyPasswordExpiring: false,
			preferredLanguage: preferredLanguage
		};
	}

	componentDidMount() {
		var match,
			pl = /\+/g, // Regex for replacing addition symbol with a space
			search = /([^&=]+)=?([^&]*)/g,
			decode = function (s: string) {
				return decodeURIComponent(s.replace(pl, ' '));
			},
			query = window.location.search.substring(1);

			var urlParams: any = {};
			while ((match = search.exec(query))) {
				urlParams[decode(match[1])] = decode(match[2]);
			}

			var requireOTP = false
			var requireMFAEnroll = false
			var userName, qr, setupCode
			var requirePasswordChange = false
			var notifyPasswordExpiring = false
			
			const app = (window as any).App;
			if (app.flash && app.flash.requireOTP) {
				requireOTP = true
				userName = app.flash.userName
			}

			if (app.flash && app.flash.requireMFAEnroll) {
				requireMFAEnroll = true
				userName = app.flash.userName
				qr = app.flash.qr
				setupCode = app.flash.setupCode
			}

			// Is password reset required?
			if (app.flash && app.flash.requirePasswordChange) {
				requirePasswordChange = true;
				userName = app.flash.userName;
			}

			if (app.flash && app.flash.notifyPasswordExpiring) {
				notifyPasswordExpiring = app.flash.notifyPasswordExpiring
			}

			this.setState(
				{
					requireOTP: requireOTP,
					requireMFAEnroll: requireMFAEnroll,
					qr: qr,
					setupCode: setupCode,
					userName: userName,
					redirectURL: urlParams.redirectURL,
					requirePasswordChange: requirePasswordChange,
					notifyPasswordExpiring: notifyPasswordExpiring
				}
			);
		
	}

	handleClickShowPasssword = () => {
		this.setState({ showPassword: !this.state.showPassword });
	};

	handleAltLogin = () => {
		window.location.href = '/saml-login';
	};

	handleChange = (prop: string) => {
		return (event: any) => {
			const state = this.state;
			state.data[prop] = event.target.value;
			this.setState(state);
		};
	};

	handleMFAMethodChange = (method: string) => {
		console.log("handleMFAMethodChange", method)
		this.setState({mfaMethod: method})
	}

	onSetupSuccess = () => {
		this.setState({
			requireMFAEnroll: false,
			mfaEnrollSuccess: true,
		})
		const app = (window as any).App;
		app.flash = undefined
	}

	forcePasswordChange = () => {
		this.setState({
			requirePasswordChange: true,
			notifyPasswordExpiring: false,
			userName: (window as any).App.flash.userName
		})
	}

	selectLanguage = (lang:string) => {
		this.setState({
			preferredLanguage: lang
		})
	}

	render() {
		var self = this;
		// console.log("login page crom core")
		const { classes }: { classes: ClassNameMap } = this.props;
		const app = (window as any).App;

		const footer = (
			<div className={classes.poweredBy} style={{width: '100%', position: 'absolute', bottom:5, textAlign: 'center' }}>
			  <div onClick={()=>{window.open('https://icginnovations.com')}} style={{width: 'fit-content', margin: 'auto', cursor: 'pointer'}}>
				<img style={{width: 120}} src="/static/assets/powered-by.png" /><br/>
				<label style={{cursor: 'inherit'}}>Leading the way in transformative business technology solutions.</label>
			  </div>
			</div>
		  );
		
		var message: React.ReactNode;

		var {requireOTP, userName, requireMFAEnroll, mfaMethod, qr, setupCode, mfaEnrollSuccess, requirePasswordChange, notifyPasswordExpiring, preferredLanguage} = this.state

		if (app.flash) {
			message = (
				<Typography variant="subtitle1" color={app.flash.type}>
					{app.flash.message}
				</Typography>
			);
		}

		if (mfaEnrollSuccess) {
			message = (
				<Typography variant="subtitle1" color={"info"}>
					You have succesfully enrolled for multi-factor authentication. Please proceed by logging in.
				</Typography>
			);
		}

		return (
			<AppView onLanguageChange={this.selectLanguage} history={this.props.history} areaKey="login">
				<div className={classes.container}>
					<Paper className={classes.paper}>
						
						{!notifyPasswordExpiring && !requirePasswordChange && !requireOTP && !requireMFAEnroll && <Typography variant="h5" gutterBottom>
							{translate("Please Login", preferredLanguage)}
						</Typography>}

						{notifyPasswordExpiring && <Typography variant="h5" gutterBottom>
							Password Expiration Notice
						</Typography>}

						{requireOTP && <Typography variant="h5" gutterBottom>
							Please Provide One Time Code
						</Typography>}

						{requireMFAEnroll && <Typography variant="h5" gutterBottom>
							MFA Enrollment Required
						</Typography>}

							<Grid container>

								{window["App"].samlAvailable && !requireOTP && !requireMFAEnroll && (<Grid item className={classes.gridItem} xs={12} sm={12} md={5} lg={5} xl={5}>
									<div>
										<Typography variant="h6" gutterBottom>
											Employees
										</Typography>
										<div className={classes.centalArea}>
											<Typography
												className={classes.employeeInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{window["App"].browserEnvironment && window["App"].browserEnvironment.BROWSER_EMPLOYEE_LOGIN_MESSAGE ? window["App"].browserEnvironment.BROWSER_EMPLOYEE_LOGIN_MESSAGE : `If you are an employee, you may login using the Single
												Sign-on integration by clicking the button below.`}
											</Typography>
										</div>
										<div className={classes.buttonBar}>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												className={classes.altButton}
												onClick={this.handleAltLogin}
											>
												Login as Employee
											</Button>
										</div>
									</div>
								</Grid>
								)}

								{window["App"].samlAvailable && !requireOTP && !requireMFAEnroll &&
									(<Grid item className={classes.gridItemSep} xs={12} sm={12} md={1} lg={1} xl={1}>
										<div />
									</Grid>
								)}

								{requireMFAEnroll && <Grid item className={classes.gridItem} xs={12} sm={12} md={window["App"].samlAvailable ? 6 :12} lg={window["App"].samlAvailable ? 6 :12} xl={window["App"].samlAvailable ? 6 :12}>
									<div className={classes.form}>
										<Grid container spacing={8}>
											<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
												<Typography style={{}} variant="subtitle1">
												You are about to enroll for multi-factor authentication.
												</Typography>
											</Grid>
										</Grid>
										<div style={{marginTop: 10}}></div>
										<MFAMethodSelect method={mfaMethod} onChange={this.handleMFAMethodChange}/>
										<div style={{marginTop: 25}}></div>
										{mfaMethod == "Email" && <MfaEmailSetup userName={userName} redirectToLogin={true} onSetupSuccess={this.onSetupSuccess} />}
										{mfaMethod == "Authenticator" && <MFAAuthenticatorSetup userName={userName} qr={qr} setupCode={setupCode} onSetupSuccess={this.onSetupSuccess} />}
									</div>
								</Grid>}

								{requirePasswordChange && <Grid item className={classes.gridItem} xs={12} sm={12} md={window["App"].samlAvailable ? 6 :12} lg={window["App"].samlAvailable ? 6 :12} xl={window["App"].samlAvailable ? 6 :12}>
									<div className={classes.form}>
										<Grid container style={{marginBottom: 25}} spacing={2}>
											<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
												<Typography style={{}} variant="subtitle1">
													Your password has expired.
												</Typography>
											</Grid>
										</Grid>
										<div style={{marginTop: 10}}></div>
										<ChangePassword userName={this.state.userName} />
										<div style={{marginTop: 25}}></div>
									</div>
								</Grid>}
								
								{!requireMFAEnroll && <Grid item className={classes.gridItem} xs={12} sm={12} md={window["App"].samlAvailable ? 6 :12} lg={window["App"].samlAvailable ? 6 :12} xl={window["App"].samlAvailable ? 6 :12}>
									
									{!requireOTP && !requireMFAEnroll && !app.flash && <Typography variant="h6" gutterBottom>
										{translate("Vendors", preferredLanguage)}
									</Typography>}

									{requireOTP && <form className={classes.form} noValidate autoComplete="off" method="POST">
										{message}
										<div className={classes.centalArea}>
											<input
												type="hidden"
												name="step"
												value={"otp"}
											/>
											<input
												type="hidden"
												name="redirectURL"
												value={this.state.redirectURL}
											/>
											<input
												type="hidden"
												name="userName"
												value={userName}
											/>
											<TextField
												name="oneTimePassword"
												label="One Time Code"
												className={classes.textField}
												value={this.state.data.otp}
												onChange={this.handleChange('otp')}
												margin="normal"
											/>
										</div>
										<div className={classes.buttonBar}>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={!this.state.data.otp}
												className={classes.button}
											>
												Submit
											</Button>
										</div>
									</form>}

									{!notifyPasswordExpiring && !requirePasswordChange && !requireOTP && <form className={classes.form} noValidate autoComplete="off" method="POST">
										{message}
										<div className={classes.centalArea}>
										{/* <div >
												<FormControl sx={{marginTop: '25px'}}>
													<InputLabel htmlFor="language">{translate("Preferred Language", preferredLanguage)}</InputLabel>
													<Select onChange={this.selectLanguage} value={preferredLanguage} name="language" className={classes.textField}
													endAdornment={
														<InputAdornment sx={{marginRight: '20px'}} position="end">
															<Language />
														</InputAdornment>
													}>
														<MenuItem value="fr">Français (fr)</MenuItem>
														<MenuItem value="es-MX">Latinoamericano (es-MX)</MenuItem>
														<MenuItem value="es">Latinoamericano (es)</MenuItem>
														<MenuItem value="en-US">US - English (en-US)</MenuItem>
														
													</Select>
												</FormControl>
											</div> */}
											<div>
												<input
													type="hidden"
													name="step"
													value={"basic"}
												/>
												<input
													type="hidden"
													name="redirectURL"
													value={this.state.redirectURL}
												/>
												<TextField
													name="userName"
													label={translate("User Name", preferredLanguage)}
													className={classes.textField}
													value={this.state.data.userName}
													onChange={this.handleChange('userName')}
													margin="normal"
												    variant="standard"
												/>
											</div>
											<div>
												<FormControl>
													<InputLabel htmlFor="password">{translate("Password", preferredLanguage)}</InputLabel>
													<Input
														name="password"
														type={self.state.showPassword ? 'text' : 'password'}
														value={self.state.data.password}
														onChange={self.handleChange('password')}
														className={classes.passwordField}
														endAdornment={
															<InputAdornment position="end">
																<IconButton size="large" onClick={self.handleClickShowPasssword}>
																	{self.state.showPassword ? (
																		<VisibilityOff />
																	) : (
																			<Visibility />
																		)}
																</IconButton>
															</InputAdornment>
														}
													/>
												</FormControl>

											</div>
											
											{/* This is used to store the selected language */}
											<Input type="hidden" name="language" value={self.state.preferredLanguage} />
											
											
										</div>
										<div className={classes.buttonBar}>

											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={!this.state.data.password || !this.state.data.userName}
												className={classes.button}
											>
												{translate("Login", preferredLanguage)}
											</Button>
										</div>

									</form>}
									{notifyPasswordExpiring && 
										<div>
										<Typography
										className={classes.resetInstructions}
										variant="subtitle1"
										gutterBottom
									>
										{app.flash.message}
									</Typography>
										<div  className={classes.buttonBar}>
										
											<Button
												variant="contained"
												color="primary"
												className={classes.noButton}
												onClick={function(){window.location.href="/"}}
											>
												No
											</Button>
											<Button
												variant="contained"
												color="primary"
												className={classes.button}
												onClick={this.forcePasswordChange}
											>
												Yes
											</Button>
										</div>
									</div>
									}
									{!notifyPasswordExpiring && !requirePasswordChange && !requireOTP && 
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												<a href="/forgot-password">{translate("Forgot your password", preferredLanguage)}</a>
											</Typography>
										}
									{window["App"].allowUnsolicitedRegistration && !requirePasswordChange && !requireOTP && (
											<Typography
												className={classes.resetInstructions}
												variant="subtitle1"
												gutterBottom
											>
												{' '}
											Not yet registered? <a href="/users/self-register"><b>Click Here</b></a> to register your account.
											</Typography>
										)}
								</Grid>}
							</Grid>
					</Paper>
				</div>
				{/* {footer} */}
			</AppView>
		);
	}
}

export default withStyles(styles)(LoginView);
